export default class SaveUserSalaryHourRequest {

    public userSalaryDayId: string = "";

    public userSalaryHourId: string | null = null;

    public constructionSiteOrWarehouseId: string = "";    
    
    public workOrderId: string = "";
    
    public normalHours: number = 0;
    
    public overtime50Hours: number = 0;
    
    public overtime100Hours: number = 0;

    public nonBillableHours: number = 0;

    /** Hours recorded as absence (internal use only; excluded from all customer-facing output). */
    public absenceHours: number = 0;
    
    public hoursPrice: number | null = null;

    public isAlarmJob: boolean = false;

    public AlarmJobPrice: number | null = null;
    
    public comment: string | null = null;
}